export default {
    help: {
        title: 'Help',
        searchMessage: 'Nothing was found'
    }
};
